import { withChartLayout } from 'components/common';
import IntakeOutput from 'components/features/chart/vital-signs/intake-output/IntakeOutput';

const IntakeOutputPage = withChartLayout('Intake - Output')(IntakeOutput);
export default IntakeOutputPage;
